import { SwiperBestItem } from "../plugin/SwiperBestItem";

export function BestItem() {
  return (
    <>
      <section className="main-sec main-best">
        <div className="best-wrap">
          <SwiperBestItem />
        </div>
      </section>
    </>
  );
}
